<script lang="ts">
  import { highlightSwift } from './highlight/swift';

  interface Props {
    code: string;
    label?: string;
    gutter?: boolean;
    currentLine?: number;
    errorLines?: number[];
  }

  let { code, label = 'コード', gutter = true, currentLine, errorLines = [] }: Props = $props();
  const lines = $derived(highlightSwift(code));
  const errors = $derived(new Set(errorLines));
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<!-- prettier-ignore -->
<pre class="code" class:has-gutter={gutter} tabindex="0" aria-label={label} data-testid="code-block"><code>{#each lines as tokens, i (i)}<span class="line" class:has-error={errors.has(i + 1)} data-line={i + 1} aria-current={currentLine === i + 1 ? 'step' : undefined}>{#each tokens as t, j (j)}{#if t.cls}<span class={t.cls}>{t.text}</span>{:else}{t.text}{/if}{/each}{tokens.length === 0 ? ' ' : ''}</span>{/each}</code></pre>
